import { Grid, TextField } from '@material-ui/core'
import React, { useState } from 'react'

const TextFieldComp = ({ fields }) => {

    return (
        <Grid xs={12} className="mbold mt30">

            {
                fields.map(({ name, onChange, initial, isRequired, validation }) => (
                    <>
                        <Grid xs={12} className="pl14">{name}</Grid>
                        <TextField
                            defaultValue={initial}
                            placeholder="(123) 123-1231"
                            id="outlined-basic"
                            required={isRequired}
                            error
                            helperText={validation}
                            onChange={(e) => onChange(e.target.value, e)}
                            variant="outlined" 
                            className="w100p" />
                    </>
                ))
            }
        </Grid> 
    )
}

export default TextFieldComp